(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-footer-menu]');
    if (!link) return;
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const panel = [...header.querySelectorAll('[data-mega-panel]')].find((element) => element.dataset.menuHandle === link.dataset.footerMenu);
    const item = panel?.closest('[data-mega-menu-item]');
    if (!item) return;
    event.preventDefault();
    queueMicrotask(() => {
      const mobileTrigger = header.querySelector('[data-header-mobile-nav-trigger]');
      if (mobileTrigger?.getClientRects().length) {
        if (mobileTrigger.getAttribute('aria-expanded') !== 'true') mobileTrigger.click();
        const drill = header.querySelector(`[data-drill-target="mega-${item.dataset.megaMenuId}"]`);
        drill?.click();
        const screen = header.querySelector(`[data-screen-id="mega-${item.dataset.megaMenuId}"]`);
        screen?.querySelector('button, a')?.focus();
      } else {
        header.scrollIntoView({ block: 'start', behavior: 'instant' });
        const trigger = item.querySelector('[data-mega-menu-trigger]');
        if (trigger?.getAttribute('aria-expanded') !== 'true') trigger?.click();
        trigger?.focus({ preventScroll: true });
      }
    });
  });
})();
